export { default } from './index.vue';



// WEBPACK FOOTER //
// ./packages/dof-pan-item/index.js